import { TableSchema } from '../metadata-schema';
import { Kernvak } from '../enums/Kernvak';
import { Vakkengroep } from '../enums/Vakkengroep';

export const dim_vk_vak: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_vk_vak",
	"description": "Definitie voor dimension tabel dim_vk_vak uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"vk_abb_vak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Officiële landelijke vakafkorting. Leeg voor schooleigen vakken."
		},
		"vk_co_vak": {
			"type": "integer",
			"label": "Vakcode",
			"category": "Vak",
			"example": "11 - 9999",
			"description": "Officiële viercijferige landelijke vakcode van dit vak. Leeg voor schooleigen vakken."
		},
		"vk_nm_kernvak": {
			"label": "Kernvak",
			"category": "Vak",
			"example": "Nederlands, Engels, wiskunde, overige vakken",
			"description": "Geeft aan of dit vak tot één van de kernvakken behoort: Nederlands, Engels of wiskunde.\nZo niet, bevat dit veld \"overige vakken\".",
			"type": "string",
			"schema": Kernvak
		},
		"vk_nm_vak": {
			"type": "string",
			"label": "Vak (officieel)",
			"category": "Vak",
			"example": "Engelse taal en literatuur, wiskunde A, ...",
			"description": "Volledige officiële landelijke vaknaam. Leeg voor schooleigen vakken."
		},
		"vk_nm_vak_kort": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Korte officiële landelijke vaknaam. Leeg voor schooleigen vakken."
		},
		"vk_nm_vak_uni": {
			"type": "string",
			"label": "Vak (uniform)",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "De vereenvoudigde naam van dit vak. Verschillende varianten van dit vak hebben dezelfde uniforme naam gekregen,\nzodat cijfers voor \"hetzelfde\" vak over verschillende jaren heen kunnen worden vergeleken voor een leerling, ongeacht\nwelke variant van dit vak van toepassing is voor de leerling. Voorbeelden van varianten met dezelfde uniforme naam zijn:\n- Nederlands omvat de vakken Nederlands, Nederlandse taal en \"Nederlandse taal en literatuur\".\n- wiskunde omvat de vakken wiskunde en wiskunde A t/m D.\n- geschiedenis omvat de vakken geschiedenis en \"geschiedenis en staatsinrichting\" en \"geschiedenis en maatschappijleer\".\n- bouwtechniek omvat de vakken \"bouwtechniek - infra\", \"bouwtechniek - metselen\", \"bouwtechniek - timmeren\" en \"bouwtechniek - schilderen/afwerkingstechnieken\".\nDit veld is leeg voor schooleigen vaknamen."
		},
		"vk_nm_vakkengroep": {
			"label": "Vakkengroep",
			"category": "Vak",
			"example": "Engels, Frans, Duits; Wis-, Natuur-, Scheikunde en Biologie, ...",
			"description": "Groep waarbij dit vak is ingedeeld:\n- Nederlands: alle varianten van Nederlands\n- Engels, Frans, Duits: alle varianten van de gebruikelijke moderne vreemde talen\n- Aardrijkskunde en Geschiedenis\n- Economische vakken\n- Wis-, Natuur-, Scheikunde en Biologie\n- Grieks en Latijn\n- Overige vakken",
			"type": "string",
			"schema": Vakkengroep
		},
		"vk_nr_kernvak_volgorde": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Volgnummer van het kernvak om te sorteren in volgorde Nederlands - Engels - wiskunde."
		}
	}
};
